export const handlerChangePage = (page, setter) => {
  setter(page);
};